import { Component, inject, input } from '@angular/core';
import { DialogComponent } from './dialog/dialog.component';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ct-dynamic-dialog',
  template: `
    <ct-extraction-dialog
      [title]="title()"
      [acceptText]="acceptText()"
      [closeText]="closeText()"
      (closeDialog)="this.ref.close(false)"
      (acceptDialog)="this.ref.close(true)">
      <ng-content></ng-content>
    </ct-extraction-dialog>
  `,
  imports: [DialogComponent],
})
export class DynamicDialogComponent {
  protected readonly ref = inject(DynamicDialogRef);

  readonly title = input.required<string>();
  readonly acceptText = input<string>('Bestätigen');
  /** `null` hides the footer close button — see `DialogComponent.closeText`. */
  readonly closeText = input<string | null>('Abbrechen');
}
